import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingScreen } from '@/components/common/LoadingScreen'
import { useCurrentProfileSuspense } from '@/hooks/convex'
import { ProfilePage } from '@/features/profile/components/ProfilePage'

export const Route = createFileRoute('/_authed/profile')({
  // Profile is already prefetched by parent _authed route
  pendingComponent: () => <LoadingScreen message="Loading profile..." />,
  component: ProfileRouteWrapper,
})

function ProfileRouteContent() {
  const { data } = useCurrentProfileSuspense()
  return <ProfilePage profileData={data} />
}

function ProfileRouteWrapper() {
  return (
    <Suspense fallback={<LoadingScreen message="Loading profile..." />}>
      <ProfileRouteContent />
    </Suspense>
  )
}
